import { Mesh, Object3D, Vector3 } from "three";
import { PhysicsLayers } from "../../../../../../PhysicsLayers";
import { ParabolicProjectile } from "../abstract/ParabolicProjectile";
import { IProjectileContainer } from "../../gamefield/IProjectileContainer";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { BatchedRenderer } from "three.quarks";
import TrailAir from "../../gamefield/particles/AirTrail";

export class CharacterProjectile extends ParabolicProjectile {
    protected trail: TrailAir;
    public get collidesWithLayer(): number {
        if (this.position.equals(new Vector3())) {
            return 0;
        }
        return 1 << PhysicsLayers.Layer1 | 1 << PhysicsLayers.Layer2;
    }

    constructor(
        protected readonly gameResources: GameResourcesPackage,
        protected readonly batchRenderer: BatchedRenderer,
        projectileContainer: IProjectileContainer,
        weaponMesh: Mesh,
        speed: number,
        damage: number,
    ) {
        super(projectileContainer, weaponMesh, speed, damage);
    }

    public override throwToPoint(target: Vector3): void {
        this.trail = new TrailAir(this, {
            parent: this.projectileContainer as Object3D,
            tubeCount: 4,
            tubeDistance: 0.1,
            tubeRadius: 0.01,
            tubeMaxPoints: 10,
            lookAheadDistance: 0.5,
            cloudTexture: this.gameResources.assets_game_particles_trail_cloud_thpng,
            cloudDistanceStep: 3,
            cloudFadeDuration: 0.5,
            cloudMaxScale: 1.5
        });
        super.throwToPoint(target);
    }

    public override destroy(): void {
        this.trail?.dispose();
        super.destroy();
    }
}
